var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7895 14.3158C32.7895 7.5144 27.7349 2 21.5 2C15.2651 2 10.2105 7.5144 10.2105 14.3158M2 14.3158H41L36.6895 41H6.31053L2 14.3158Z",
    stroke: "#BDFA3C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3148 25.6053C15.4485 25.6053 16.3675 24.6863 16.3675 23.5526C16.3675 22.419 15.4485 21.5 14.3148 21.5C13.1812 21.5 12.2622 22.419 12.2622 23.5526C12.2622 24.6863 13.1812 25.6053 14.3148 25.6053Z",
    fill: "#13FCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3428 30.7368C15.3428 30.7368 17.3954 33.8158 21.5007 33.8158C25.6059 33.8158 27.6586 30.7368 27.6586 30.7368",
    stroke: "#13FCFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.685 25.6053C29.8186 25.6053 30.7376 24.6863 30.7376 23.5526C30.7376 22.419 29.8186 21.5 28.685 21.5C27.5513 21.5 26.6323 22.419 26.6323 23.5526C26.6323 24.6863 27.5513 25.6053 28.685 25.6053Z",
    fill: "#13FCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileIcon);
export default __webpack_public_path__ + "static/media/smile_icon.7893f6581545bbbfebbbd687217aa84c.svg";
export { ForwardRef as ReactComponent };